import { area, curveStep, curveMonotoneX } from 'd3-shape';
export var calculateArea = function (curve, xScale, yScale, labelSelector, keyName, minValue, maxValue, isNegativeSeries) {
    var lineShapeType;
    switch (curve) {
        case 'spline':
            lineShapeType = area().curve(curveMonotoneX);
            break;
        case 'step':
            lineShapeType = area().curve(curveStep);
            break;
        default:
            lineShapeType = area();
            break;
    }
    return lineShapeType
        .x(function (d) {
        return xScale(d[labelSelector]);
    })
        .y1(function (d) {
        if (isNegativeSeries) {
            if (maxValue !== 'auto')
                return yScale(yScale.ticks()[yScale.ticks().length - 1]);
            return yScale(0);
        }
        return yScale(d[keyName]);
    })
        .y0(function (d) {
        if (isNegativeSeries) {
            return yScale(d[keyName]);
        }
        if (minValue !== 'auto' && minValue > 0)
            return yScale(yScale.ticks()[0]);
        return yScale(0);
    });
};
